import React, { useState, useEffect, useContext } from "react"
import { formatNumberWithCommas } from "../../common/utility"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Input,
  CardTitle,
} from "reactstrap"
import { Link } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import ToastDialog from "components/Common/ToastDialog"
import { CartContext } from "context/cartContext"
import _ from "lodash"

const EcommerceCart = () => {
  document.title = "Cart | DMS"

  const [productList, setproductList] = useState([])
  const [isEmpty, setIsEmpty] = useState(false)
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [productQuantity, setProductQuantity] = useState({})
  const { getCartData, removeItemFromCart, updateItemCart } =
    useContext(CartContext)
    const [hasError, setHasError] = useState([]);

  async function removeCartItem(id) {
    try {
      let res = await removeItemFromCart({ productId: id })
      const { message } = res
      setToastInfo({
        message: message,
        showToast: true,
        role: "success",
      })
      fetchCartList()
    } catch (err) {
      setToastInfo({
        message: err.message,
        showToast: true,
        role: "error",
      })
    }
  }

  function countUP(id, minQty, maxQty, lotSize) {
    const product = productList.find(i => i.id === id)
    updateCartItem({
      cartId: product.id,
      quantity: Number(product.quantity) + (lotSize || 1),
      productId: product.product.id,
      minQty,
      maxQty,
      lotSize,
    })
  }

  function countDown(id, minQty, maxQty, lotSize) {
    const product = productList.find(i => i.id === id)
    updateCartItem({
      cartId: product.id,
      quantity: Number(product.quantity) - (lotSize || 1),
      productId: product.product.id,
      minQty,
      maxQty,
      lotSize,
    })
  }

  useEffect(() => {
    fetchCartList()
  }, [])

  const fetchCartList = async () => {
    try {
      let res = await getCartData()
      const { data: responseData } = res
      if (responseData.data.length === 0) {
        setIsEmpty(true)
      }
      setproductList(responseData.data)
      const newQuantities = {}
      responseData.data.forEach(product => {
        newQuantities[product.id] = product.quantity
      })
      setProductQuantity(newQuantities)
    } catch (e) {
      setToastInfo({
        message: err.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const updateCartItem = async (product, minQty, maxQty, lotSize) => {
    try {
      let res = await updateItemCart(product, minQty, maxQty, lotSize)
      const { message } = res
      setToastInfo({
        message: message,
        showToast: true,
        role: "success",
      })
      fetchCartList()
    } catch (err) {
      fetchCartList()
      setToastInfo({
        message: err.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const debouncedOnChange = _.debounce(
    (value, product,  updateCartItem, productList) => {
      const intValue = parseInt(value, 10)
      const updatedValue = isNaN(intValue) ? product?.product?.minQty : intValue
      const productData = productList.find(i => i.id === product.id)
      updateCartItem({
        cartId: productData.id,
        quantity: updatedValue,
        productId: productData.product.id,
        minQty: product?.product?.minQty,
        maxQty: product?.product?.maxQty,
        lotSize: product?.product?.lotSize,
      })
    },
    300
  )

  const calculateGrandTotal = () => {
    let grandTotal = 0
    productList.forEach(product => {
      grandTotal += product.product.sellingPrice * product.quantity
    })
    return grandTotal
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Ecommerce" breadcrumbItem="Cart" />
          {!isEmpty ? (
            <Row>
              <Col xl={8}>
                <Card>
                  <CardBody>
                    <div className="table-responsive">
                      <Table className="table align-middle mb-0 table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>Product</th>
                            <th>Product Name</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Total</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productList.map((product, index) => {
                            let imgUrl = product?.product?.productImages?.find(
                              i => i?.image?.primary === true
                            )
                            return (
                              <>
                                <tr key={product.id}>
                                  <td>
                                    <div
                                      className={
                                        imgUrl?.image?.paths?.original
                                        && !hasError[index]
                                          ? "td-product-img"
                                          : "td-no-product-img"
                                      }
                                    >
                                      <Link
                                        to={
                                          "/customer/product-detail/" +
                                          product?.product?.id
                                        }
                                        className="text-dark"
                                      >
                                        {(imgUrl?.image?.paths?.original && !hasError[index]) ? (
                                          <img
                                            src={
                                              process.env.REACT_APP_IMAGE_URL +
                                              imgUrl?.image?.paths?.original
                                            }
                                            alt=""
                                            style={{
                                              cursor: "pointer",
                                              width: "100%",
                                              height: "4.5rem",
                                            }}
                                            className="img-fluid d-block"
                                            onError={(e) => {
                                              e.target.onerror = null; // Prevents infinite looping if default image also fails to load
                                              e.target.src = '/no-image.png';
                                              e.target.style.width = '2.5rem';
                                              e.target.style.height = '2.5rem';
                                              setHasError(prevState => {
                                                const newState = [...prevState];
                                                newState[index] = true;
                                                return newState;
                                              });
                                            }}

                                          />
                                        ) : (
                                          <img
                                            src={"/no-image.png"}
                                            alt=""
                                            className="img-fluid mx-auto d-block"
                                            style={{
                                              // height: "10rem",
                                              cursor: "pointer",
                                              width: "2rem",
                                            }}
                                          />
                                        )}
                                      </Link>
                                    </div>
                                  </td>
                                  <td>
                                    <h5 className="font-size-14 text-truncate">
                                      <Link
                                        to={
                                          "/customer/product-detail/" +
                                          product?.product?.id
                                        }
                                        className="text-dark"
                                      >
                                        {product.product.productName}
                                      </Link>
                                    </h5>
                                  </td>
                                  <td>
                                    {formatNumberWithCommas(
                                      product.product.sellingPrice
                                    )}
                                  </td>
                                  <td>
                                    <div style={{ width: "150px" }}>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                        className="input-group"
                                      >
                                        <div className="input-group-prepend">
                                          <button
                                            type="button"
                                            className="btn"
                                            style={{
                                              border: "none",
                                              fontSize: "20px",
                                            }}
                                            onClick={() => {
                                              countDown(
                                                product.id,
                                                +product.product.minQty,
                                                +product.product.maxQty,
                                                +product.product.lotSize
                                              )
                                            }}
                                          >
                                            -
                                          </button>
                                        </div>
                                        <Input
                                          type="text"
                                          value={productQuantity[product.id]}
                                          name="demo_vertical"
                                          className="text-center"
                                          style={{ height: "2.1rem" }}
                                          onChange={e => {
                                            const value = parseInt(
                                              e.target.value,
                                              10
                                            )
                                            const updatedValue = isNaN(value)
                                              ? 1
                                              : value
                                            setProductQuantity(prevQuantities => ({
                                              ...prevQuantities,
                                              [product.id]: updatedValue,
                                            }))
                                            debouncedOnChange(
                                              updatedValue,
                                              product,
                                              updateCartItem,
                                              productList
                                            )
                                          }}
                                        />
                                        <div className="input-group-append">
                                          <button
                                            type="button"
                                            className="btn"
                                            style={{
                                              border: "none",
                                              fontSize: "18px",
                                            }}
                                            onClick={() => {
                                              countUP(
                                                product.id,
                                                +product.product.minQty,
                                                +product.product.maxQty,
                                                +product.product.lotSize
                                              )
                                            }}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    {formatNumberWithCommas(
                                      product.product.sellingPrice *
                                        product.quantity
                                    )}
                                  </td>
                                  <td>
                                    <Link
                                      to="#"
                                      onClick={() =>
                                        removeCartItem(product.product.id)
                                      }
                                      className="action-icon text-danger"
                                    >
                                      {" "}
                                      <i className="mdi mdi-trash-can font-size-18" />
                                    </Link>
                                  </td>
                                </tr>
                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col xl="4">
                {productList.length > 0 && (
                  <Card>
                    <CardBody>
                      <CardTitle className="mb-3">Order Summary</CardTitle>

                      <div className="table-responsive">
                        <Table className="table mb-0">
                          <tbody>
                            <tr>
                              <td>Grand Total :</td>
                              <td>
                                {formatNumberWithCommas(calculateGrandTotal())}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <Col sm="12">
                          <div className="d-flex justify-content-between mt-3">
                            <Link
                              to="/customer/listProduct"
                              className="btn btn-outline-secondary"
                            >
                              <i className="mdi mdi-arrow-left me-1" /> Continue
                              Shopping{" "}
                            </Link>
                            <Link
                              to="/customer/place-order"
                              className="btn btn-success"
                            >
                              <i className="mdi mdi-arrow-right me-1" /> Proceed{" "}
                            </Link>
                          </div>
                        </Col>
                      </div>
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>
          ) : (
            <>
              <div style={{ textAlign: "center", marginTop: "50px" }}>
                <h2>Your Cart is Empty</h2>
                <p>
                  Looks like you haven't added any products to your cart yet.
                </p>
                <img
                  src="/empty.svg"
                  alt="Empty Cart"
                  style={{ width: "300px", height: "300px", marginTop: "20px" }}
                />
                <p>
                  <a href="/customer/listProduct">Browse Products</a> to find
                  items to add to your cart.
                </p>
              </div>
            </>
          )}
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  )
}

export default EcommerceCart
